export const ABANDONED_CART_TEST = 'abandoned_cart_version_test';
export const CART_URL = '/cart';
export const ABANDONED_CART_TOASTS_SS_KEY = 'abandoned_cart_toasts';
export const ABANDONED_CART_BANNERS_SS_KEY = 'abandoned_cart_banners';
export const SECOND_PROMO_PARAM = '?secondPromo=true';
export const MATTRESS_CATEGORY = 'Mattress';
export const ABANDONED_CHECKOUT_EXPIRY_VALUE = 'expired';
export const ABANDONED_CHECKOUT_EXPIRY_COOKIE =
  `${process.env.ABANDONED_CHECKOUT_AB_TEST_COOKIE_NAME}=${ABANDONED_CHECKOUT_EXPIRY_VALUE}`;
